/**
 * Created by Cemali Gencer on 18.1.2017.
 */
$(document).ready(function () {
    $(".slidingDiv").hide();
    $(".slidingDivdeliver").hide();
    $(".slidingDivinfo").hide();


    $('.show_hide').click(function (e) {
        $(".slidingDiv").slideToggle("fast");

       if ($('#minuscollapse').hasClass('fa-plus-square-o') ) {
            $('#minuscollapse ').removeClass("fa-plus-square-o");
            $('#minuscollapse').addClass("fa-minus-square-o");
        }

        else if ($('#minuscollapse').hasClass('fa-minus-square-o') ) {
            $('#minuscollapse').removeClass("fa-minus-square-o");
            $('#minuscollapse').addClass("fa-plus-square-o");
        }
        e.preventDefault();
    });

    $('.show_hided').click(function (e) {
        $(".slidingDivdeliver").slideToggle("fast");

        if ($('#minuscollapsed').hasClass('fa-plus-square-o') ) {
            $('#minuscollapsed').removeClass("fa-plus-square-o");
            $('#minuscollapsed').addClass("fa-minus-square-o");
        }

        else if ($('#minuscollapsed').hasClass('fa-minus-square-o') ) {
            $('#minuscollapsed').removeClass("fa-minus-square-o");
            $('#minuscollapsed').addClass("fa-plus-square-o");
        }
        e.preventDefault();
    });

    $('.show_hidei').click(function (e) {
        $(".slidingDivinfo").slideToggle("fast");

        if ($('#minuscollapsei').hasClass('fa-plus-square-o') ) {
            $('#minuscollapsei').removeClass("fa-plus-square-o");
            $('#minuscollapsei').addClass("fa-minus-square-o");
        }

        else if ($('#minuscollapsei').hasClass('fa-minus-square-o') ) {
            $('#minuscollapsei').removeClass("fa-minus-square-o");
            $('#minuscollapsei').addClass("fa-plus-square-o");
        }
        e.preventDefault();
    });



});